import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import KitPage from "./pages/KitPage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import BilanPage from "./pages/BilanPage";
import MerciPage from "./pages/MerciPage";
import AdminPage from "./pages/AdminPage";
import { LANGS } from "./i18n";

const LangRedirect = () => {
  const nav = (navigator.language || "fr").slice(0, 2).toLowerCase();
  const target = LANGS.includes(nav) ? nav : "fr";
  return <Navigate to={`/${target}/`} replace />;
};

const GuardedLayout = () => {
  const { lang } = useParams();
  if (!LANGS.includes(lang)) return <Navigate to="/fr/" replace />;
  return <Layout />;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LangRedirect />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/:lang" element={<GuardedLayout />}>
          <Route index element={<HomePage />} />
          <Route path="kit-digital-premium" element={<KitPage />} />
          <Route path="a-propos" element={<AboutPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="nosotros" element={<AboutPage />} />
          <Route path="sobre" element={<AboutPage />} />
          <Route path="services" element={<ServicesPage />} />
          <Route path="bilan" element={<BilanPage />} />
          <Route path="merci" element={<MerciPage />} />
          <Route path="*" element={<Navigate to="." replace />} />
        </Route>
        <Route path="*" element={<LangRedirect />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
